import { render, staticRenderFns } from "./gj-copy-icon.vue?vue&type=template&id=0fdeb50c&scoped=true&"
import script from "./gj-copy-icon.vue?vue&type=script&lang=js&"
export * from "./gj-copy-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdeb50c",
  null
  
)

export default component.exports